module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<footer>© Riseplus Technology. All Rights Reserved 2018.</footer>"